export default "__VITE_ASSET__BbyBSxCQ__"